import React, {useContext} from 'react';
import './Cashpoints.less';
import {Block} from "compositions/block/Block.tsx";
import {Card, CardStyles} from "elements/card/Card.tsx";
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {CashpointsBalance} from "elements/cashpoints-balance/CashpointsBalance";
import {CashpointsTransactionList} from "compositions/cashpoints-transaction-list/CashpointsTransactionList";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const CASHPOINTS_POPUP = 'CASHPOINTS_POPUP';

export const Cashpoints = ({amount, transactions, cashpointsName, onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <PseudoPagePopup
		title={cashpointsName}
		onBackClick={onOverlayClick}>
		<div className="cashpoints">
			<div className="cashpoints__current">
				<Block
					title={getSafeTranslation('CashpointsPopup.currentBlockTitle', translations)}
					isNonScalable>
					<Card style={CardStyles.NESTED}>
						<CashpointsBalance text={amount}/>
					</Card>
				</Block>
			</div>
			{
				transactions && transactions.length > 0 && (
					<div className="cashpoints__transactions">
						<Block
							title={getSafeTranslation('CashpointsPopup.transactionsBlockTitle', translations)}
							isNonScalable>
							<Card style={CardStyles.NESTED}>
								<CashpointsTransactionList
									transactions={transactions}
								/>
							</Card>
						</Block>
					</div>
				)
			}
		</div>
	</PseudoPagePopup>
}
